/* YESHUALL V5.4.11. Curated quick-add in the native Dawn cart drawer.
   Multi-variant products use their product page to avoid selecting the wrong size/color. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-ys-cart-add]');
  if (!button || !button.closest('cart-drawer')) return;
  event.preventDefault();
  if (button.disabled) return;
  const drawer = button.closest('cart-drawer');
  const group = button.closest('.ys-cart__recs');
  const error = group?.querySelector('.ys-cart__rec-error');
  const variantId = Number(button.dataset.variantId);
  if (!Number.isSafeInteger(variantId) || variantId < 1) return;
  button.disabled = true;
  if (error) { error.hidden = true; error.textContent = ''; }
  try {
    const response = await fetch((() => { const base = window.routes?.cart_add_url || '/cart/add'; return base.endsWith('.js') ? base : `${base}.js`; })(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: drawer.getSectionsToRender().map(({ id }) => id),
        sections_url: window.location.pathname,
      }),
    });
    const result = await response.json();
    if (!response.ok || result.status || !result.sections?.['cart-drawer']) {
      throw new Error(result.description || result.message || 'Could not add the item. Please try again.');
    }
    drawer.renderContents(result);
  } catch (e) {
    if (error) { error.textContent = e.message || 'Please try again.'; error.hidden = false; }
    button.disabled = false;
  }
});
